import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Table, Input, Icon} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import Progress from './progress';

class YearLimit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'editing': !props.values.annualAmount,
      'projectedAmount': props.values.annualAmount,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSeeClick = this.handleSeeClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  handleEditClick() {
    this.setState({'editing': true});
  }

  handleSeeClick() {
    const {values} = this.props;
    this.props.getProviderOrderLimit({'year': values.year});
  }

  handleSaveClick() {
    const {projectedAmount} = this.state;
    const {values} = this.props;

    if (!Number(projectedAmount)) {
      this.props.addMessageBoxWarning(
        'El monto permitido no puede ser 0'
      );
      return;
    }

    if (Number(projectedAmount) < Number(values.realAmount)) {
      this.props.addMessageBoxWarning(
        'El monto permitido no puede ser menor al monto ya consumido'
      );
      return;
    }

    this.props.saveProviderOrderLimit({
      'year': values.year,
      'annualAmount': Number(projectedAmount),
    });
    this.setState({'editing': false});
  }

  handleCancelClick() {
    this.setState({'editing': false});
  }

  handleChange(event, data) {
    this.setState({'projectedAmount': data.value});
  }

  renderYearAmount() {
    const {editing, projectedAmount} = this.state;
    const {values} = this.props;

    if (!editing) {
      return (
        <React.Fragment>
          $ {getNumericValue(values.annualAmount, 2)}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Grid>
          <Grid.Row>
            <Grid.Column width='10' className='amount-limit'>
              <Input
                fluid
                autoFocus
                size='mini'
                type='number'
                step='any'
                min={0}
                value={projectedAmount}
                onChange={this.handleChange}
              />
            </Grid.Column>
            <Grid.Column
              width='6'
              verticalAlign='middle'
              className='amount-actions'
            >
              <Icon
                link
                name='check'
                color='blue'
                size='large'
                onClick={this.handleSaveClick}
              />
              <Icon
                link
                name='close'
                color='blue'
                size='large'
                onClick={this.handleCancelClick}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }

  renderEditIcon(values) {
    const date = moment();

    if (values.year < date.year() || this.state.editing) {
      return null;
    }

    return (
      <Icon
        link
        name='write'
        color='blue'
        size='large'
        onClick={this.handleEditClick}
      />
    );
  }

  render() {
    const {editing} = this.state;
    const {values} = this.props;

    return (
      <Table.Row>
        <Table.Cell textAlign='center' width='1'>
          {values.year}
        </Table.Cell>
        <Table.Cell textAlign='center' width={editing ? '3' : '2'}>
          {this.renderYearAmount()}
        </Table.Cell>
        <Table.Cell textAlign='center' width='2'>
          $ {getNumericValue(values.realAmount, 2)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={editing ? '8' : '9'}>
          <Progress spent={values.realAmount} projected={values.annualAmount} />
        </Table.Cell>
        <Table.Cell textAlign='center' width='1'>
          {this.renderEditIcon(values)}
          <Icon
            link
            className='bar chart'
            color='blue'
            size='large'
            onClick={this.handleSeeClick}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

const {addMessageBoxWarning, saveProviderOrderLimit, getProviderOrderLimit} =
  Actions;

export default connect(null, {
  addMessageBoxWarning,
  saveProviderOrderLimit,
  getProviderOrderLimit,
})(YearLimit);
